
























































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import Address from "@/employee/components/shared/Address.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  DebitCardInfo,
  FetchState
} from "@/shared/types";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useDebitCardsStore } from "@/shared/store/debitCards";

enum WizardSteps {
  chooseAction,
  confirmDeactivate,
  verifyReissueAddress,
  confirmReissue,
  deactivateComplete,
  reissuePending
}

const confirmationSteps = [
  WizardSteps.confirmDeactivate,
  WizardSteps.confirmReissue
];

const finalSteps = [
  WizardSteps.deactivateComplete,
  WizardSteps.reissuePending
];

@Component({
  components: {
    Button,
    Address,
    GenericLoadingSpinner
  }
})
export default class HsaDebitCardWizard extends Vue {
  @Prop() debitCard: DebitCardInfo;

  WizardSteps = WizardSteps;
  wizardStep = WizardSteps.chooseAction;
  isGoingToReissue = true;
  didTryAndFail = false;
  readonly actionOptions = [
    { text: "Deactivate this card and send me a new one", value: true },
    { text: "Just deactivate this card", value: false }
  ];

  contactInfoStore = useContactInfoStore();
  debitCardsStore = useDebitCardsStore();


  mounted () {
    this.contactInfoStore.getContactInformation();
  }

  closeButtonClicked () {
    this.closeWizard();
  }

  closeWizard () {
    this.$emit("close-wizard");
  }

  get isLoading () {
    return this.debitCardsStore.isChangingStatus ||
        this.contactInfoStore.contactInformationState === FetchState.Loading;
  }

  get fullName () {
    return `${this.debitCard.firstName} ${this.debitCard.lastName}`;
  }

  get navigationDisabled () {
    return this.debitCardsStore.isChangingStatus || this.isLoading;
  }

  get wizardIsComplete () {
    return finalSteps.some(step => step === this.wizardStep);
  }

  get nextButtonText () {
    if (confirmationSteps.some(step => step === this.wizardStep)) {
      if (this.didTryAndFail) {
        return "Retry";
      }

      return "Confirm";
    }

    if (this.wizardIsComplete) {
      return "Return";
    }

    return "Continue";
  }

  nextButtonClicked () {
    switch (this.wizardStep) {
      case WizardSteps.chooseAction:
        if (this.isGoingToReissue) {
          this.wizardStep = WizardSteps.verifyReissueAddress;
        } else {
          this.wizardStep = WizardSteps.confirmDeactivate;
        }
        break;

      case WizardSteps.confirmDeactivate:
        this.debitCardsStore.closeDebitCard(this.debitCard)
            .then(_ => {
              this.wizardStep = WizardSteps.deactivateComplete;
            })
            .catch(_ => {
              this.didTryAndFail = true;
            });
        break;

      case WizardSteps.verifyReissueAddress:
        this.wizardStep = WizardSteps.confirmReissue;
        break;

      case WizardSteps.confirmReissue:
        this.debitCardsStore.reissueDebitCard(this.debitCard)
            .then(_ => {
              this.wizardStep = WizardSteps.reissuePending;
            })
            .catch(_ => {
              this.didTryAndFail = true;
            });
        break;

      case WizardSteps.deactivateComplete:
        this.closeWizard();
        break;

      case WizardSteps.reissuePending:
        this.closeWizard();
        break;
    }
  }

  get displayPreviousButton () {
    return !this.wizardIsComplete && this.wizardStep !== WizardSteps.chooseAction;
  }

  previousButtonClicked () {
    switch (this.wizardStep) {
      case WizardSteps.confirmDeactivate:
        this.wizardStep = WizardSteps.chooseAction;
        break;

      case WizardSteps.verifyReissueAddress:
        this.wizardStep = WizardSteps.chooseAction;
        break;

      case WizardSteps.confirmReissue:
        this.wizardStep = WizardSteps.verifyReissueAddress;
        break;
    }
  }
}
